import ExcelJS from "exceljs";

export async function buildWorkbookWithPivotSafe(opts = {}) {
  const workbook = opts.workbook || new ExcelJS.Workbook();
  const dataSheetName = opts.dataSheetName || "Data";
  const sheet = workbook.getWorksheet(dataSheetName) || workbook.addWorksheet(dataSheetName);

  if (opts.fields && opts.records) {
    sheet.columns = opts.fields.map((field) => ({ header: field.name, key: field.name }));
    if (sheet.rowCount > 1) {
      for (let rowNumber = sheet.rowCount; rowNumber >= 2; rowNumber -= 1) {
        sheet.removeRow(rowNumber);
      }
    }
    sheet.addRows(
      opts.records.map((row) => opts.fields.map((field) => row[field.name])),
    );
  }

  const buffer = await workbook.xlsx.writeBuffer();
  return new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}